import {
  authorizePasswordlessService,
  consentOAuthScopes,
  consentOAuthScopesExtended,
  REACT_PUBLIC_CONSENT_CLIENT_ID,
  requestOptions,
} from "../constants/static";
import { authorizeUrl, returnUrl } from "../constants/urls";
import { challengeFromVerifier, generateRandomString } from "../constants/utils";
import { getStateCode } from "../utils/getStateCode";

export const authorize = async (
  cidmUrl: string,
  isScopeExtended = false
): Promise<{ isError: boolean } | undefined> => {
  // Ensure a slash is present between base URL and path
  const authorizeURL = cidmUrl + authorizeUrl;
  const codeVerifier = generateRandomString();
  const nonce = generateRandomString();
  const state = generateRandomString();
  sessionStorage.setItem("codeVerifier", codeVerifier);
  const code_challenge = await challengeFromVerifier(codeVerifier);

  const params: Record<string, string> = {
    client_id: REACT_PUBLIC_CONSENT_CLIENT_ID,
    response_type: "code",
    scope: isScopeExtended ? consentOAuthScopesExtended : consentOAuthScopes,
    redirect_uri: window.location.origin + returnUrl,
    state,
    code_challenge_method: "S256",
    service: authorizePasswordlessService,
    locale: getStateCode().toUpperCase(),
    code_challenge,
    nonce,
  };

  const queryString = Object.keys(params)
    .map(key => {
      const value = params[key];
      return encodeURIComponent(key) + "=" + encodeURIComponent(value);
    })
    .join("&");
  try {
    const authResult = await fetch(`${authorizeURL}?${queryString}`, requestOptions);
    if (authResult.type === "opaqueredirect") {
      window.location.assign(`${authorizeURL}?${queryString}`);
    } else {
      return { isError: true };
    }
  } catch (err) {
    return { isError: true };
  }
};
